import checkIfLogged from '../../Login/CheckLogged'

const tmp = checkIfLogged()

const initialState = {
    hasInternet: true,
    loggedIn: tmp.status,
    loggedUname: tmp.name,
    persons: []
};

const rootReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_INET_STATUS:
            return { ...state, hasInternet: action.payload }
        case SET_LOGGED:
            return { ...state, loggedIn: action.payload.bool,
                        loggedId: action.payload.uid,
                        loggedUname: action.payload.name
                   }
        case BKUP_PERSONS:
            return { ...state, persons: action.payload }
        default:
            return state;
    }
};
export default rootReducer;

const SET_INET_STATUS = "SET_INET_STATUS";
const SET_LOGGED = "SET_LOGGED";
const BKUP_PERSONS = "BKUP_PERSONS";